import styled from "@emotion/styled";
import { Box, Button, Typography } from "@mui/material";

export const PageNotFoundContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 2rem;
`;

export const ErrorHeading = styled(Typography)`
  color: #ff0000; // Customize error color
`;

export const ErrorMessage = styled(Typography)`
  color: #666666;
  margin-bottom: 2rem;
`;

export const ButtonLink = styled(Button)`
  color: #fff;
  background-color: #007bff;
`;
